<script setup lang="ts">
  import CheckIcon from '@/shared/assets/icons/CheckIcon.svg';
  import { IconImage } from '@/shared/ui';

  const props = defineProps<{
    modelValue: boolean;
  }>();

  const emit = defineEmits<{
    'update:modelValue': [value: boolean];
  }>();

  const handleChange = () => {
    emit('update:modelValue', !props.modelValue);
  };
</script>

<template>
  <div class="flex items-center justify-start gap-2">
    <div class="relative w-4 h-4 flex items-center justify-center">
      <input
        id="remember"
        type="checkbox"
        :checked="props.modelValue"
        class="w-4 h-4 border-lightgray-xx rounded-sm appearance-none bg-white-01 border border-light-gray-xx checked:bg-gray-07 dark:checked:bg-gray-15 z-10"
        @change="handleChange"
      >
      <span
        v-if="props.modelValue"
        class="absolute flex items-center justify-center pointer-events-none z-20"
      >
        <IconImage
          class="text-white"
          :src="CheckIcon"
          alt="Check"
        />
      </span>
    </div>
    <label for="remember">Lembrar de mim</label>
  </div>
</template>
